"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SortOrder = void 0;
var SortOrder;
(function (SortOrder) {
  SortOrder["ASC"] = "ASC";
  SortOrder["DESC"] = "DESC";
})(SortOrder = exports.SortOrder || (exports.SortOrder = {}));